// src/components/pos/CategorySidebar.jsx
import { useState, useEffect } from 'react'
import CategoryService from '../../services/categoryService'

const CategorySidebar = ({ 
  selectedCategory, 
  onCategorySelect, 
  className = ""
}) => {
  const [categories, setCategories] = useState([])

  // Fetch categories from API
  const fetchCategories = async () => {
    try {
      const response = await CategoryService.getAllCategories()
      
      if (response && response.success) {
        let categoriesData = response.data || []
        
        // Handle different response structures
        if (categoriesData.categories) {
          categoriesData = categoriesData.categories
        }
        
        // Filter only active categories
        const activeCategories = categoriesData.filter(category => 
          category && 
          category.isActive !== false && 
          category.name && 
          category._id
        )
        
        setCategories(activeCategories)
      }
    } catch (error) {
      console.error('Error fetching categories:', error)
    }
  }

  // Initial load and auto-refresh
  useEffect(() => {
    fetchCategories()
    const interval = setInterval(fetchCategories, 30000) // 30 seconds
    return () => clearInterval(interval)
  }, [])

  return (
    <div className={`flex flex-col h-full max-h-[calc(100vh-200px)] ${className}`}>
      {/* All Button - Fixed at top */}
      <button
        onClick={() => onCategorySelect?.(null)}
        className={`w-full p-3 rounded-lg text-sm font-medium transition-colors mb-2 flex-shrink-0 ${
          selectedCategory === null
            ? 'bg-orange-500 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
        }`}
      >
        All
      </button>

      {/* Scrollable Category Buttons Container */}
      <div className="flex-1 overflow-y-auto space-y-2 pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {categories.map((category) => (
          <button
            key={category._id}
            onClick={() => onCategorySelect?.(category)}
            className={`w-full p-3 rounded-lg text-sm font-medium transition-colors ${
              selectedCategory?._id === category._id
                ? 'bg-orange-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default CategorySidebar